export default __webpack_public_path__ + "static/media/s5.5dfb1d48.jpg";